import React from "react";
import StyledH1Heading from "../../common/components/styledH1Heading/StyledH1Heading";

const LegalNotices = ({ heading, content }) => {
  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90%] sm:w-4/5 lg:w-8/12 xl:w-[52%] flex flex-col items-center justify-center mt-8 gap-8">
        <div>
          <StyledH1Heading fontColor={"textGradient text-center"}>
            {heading}
          </StyledH1Heading>
        </div>
        <div className="bg-[#000] border border-regular-orange rounded-2xl px-4 sm:px-6 py-5 lg:p-8">
          {content}
        </div>
      </div>
    </div>
  );
};

export default LegalNotices;
